"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("../../../FoodMenu.context");

var _modifiers = require("../modifiers");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

var _ItemModal = _interopRequireDefault(require("./ItemModal"));

var ItemBasic = function ItemBasic(_ref) {
  var id = _ref.id,
      name = _ref.name,
      description = _ref.description,
      price = _ref.price,
      image = _ref.image,
      _ref$showDescription = _ref.showDescription,
      showDescription = _ref$showDescription === void 0 ? true : _ref$showDescription,
      _ref$showModifierSets = _ref.showModifierSets,
      showModifierSets = _ref$showModifierSets === void 0 ? false : _ref$showModifierSets;
  return _react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var items = _ref2.items,
        modifierSets = _ref2.modifierSets;

    var item = _menu["default"].getItemById(items, id);

    var itemModifierSetIds = item.modifier_sets;

    var itemModifierSets = _menu["default"].getItemModifierSets(itemModifierSetIds, modifierSets);

    return _react["default"].createElement(_ItemModal["default"], {
      trigger: _react["default"].createElement(_semanticUiReact.List.Item, {
        style: {
          paddingBottom: '1rem'
        }
      }, _react["default"].createElement("div", {
        style: {
          display: 'flex'
        }
      }, _react["default"].createElement(_semanticUiReact.Header, {
        as: "h5",
        style: {
          paddingRight: '1em'
        }
      }, name), _react["default"].createElement(_semanticUiReact.Divider, {
        style: {
          flexGrow: 1,
          margin: '1rem 0 0 0'
        }
      }), parseFloat(price) > 0 && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h5",
        style: {
          paddingLeft: '1em'
        }
      }, "$", price)), showDescription && _react["default"].createElement("p", {
        style: {
          marginBottom: '0.5rem'
        }
      }, description), showModifierSets && itemModifierSets.map(function (_ref3) {
        var id = _ref3.id;
        return _react["default"].createElement(_modifiers.ModifierSetBasic, {
          modifierSetId: id
        });
      })),
      id: id,
      name: name,
      description: description,
      price: price,
      image: image
    });
  });
};

var _default = ItemBasic;
exports["default"] = _default;